export const hostname = 'THIS_ENVIRONMENT_DOES_NOT_HAVE_HOSTNAME_USE_ENV_VARS';
